import {enum_to_hash} from "@/helpers.js"

export default {
    "LOW": 10,
    "NORMAL": 20,
    "HIGH": 30,
    "URGENT": 40
}

export const options = [
    {id: 10, text: 'LOW', class: "bg-gray-200"},
    {id: 20, text: 'NORMAL', class: "bg-blue-200 text-blue-800"},
    {id: 30, text: 'HIGH', class: "bg-orange-200 text-orange-800"},
    {id: 40, text: 'URGENT', class: "bg-red-200 text-red-800"},
]

export const hash = enum_to_hash(options)
